export const questionnaireEvaluationGetFailureReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isSaveSuccess: false });
};
//# sourceMappingURL=questionnaireEvaluationGetFailureReducer.js.map